module.exports = {
  "defaultCurrency": "USD",
  "currencies": [
    {
      "id": 2,
      "code": "USD",
      "name": "$USD",
      "change_store": false,
      "store": null,
      "base_currency": "USD"
    }
  ]
}